import { ChangeEvent } from 'react';
import { FunnelIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Checkbox } from '@tailwindComponents/Checkbox';
import { FilterSelect } from '@tailwindComponents/FilterSelect';
import { ALL_MARKETS } from './customerFacets';

export interface CustomerToolbarProps {
  searchQuery: string;
  onSearchQueryChange: (event: ChangeEvent<HTMLInputElement>) => void;
  market: string;
  onMarketChange: (market: string) => void;
  marketOptions: { label: string; value: string }[];
  segment: string | null;
  onSegmentChange: (segment: string | null) => void;
  segmentOptions: { label: string; value: string }[];
  includeArchived: boolean;
  onIncludeArchivedChange: (value: boolean) => void;
  isRailVisible: boolean;
  onToggleRail: () => void;
}

export function CustomerToolbar({
  searchQuery,
  onSearchQueryChange,
  market,
  onMarketChange,
  marketOptions,
  segment,
  onSegmentChange,
  segmentOptions,
  includeArchived,
  onIncludeArchivedChange,
  isRailVisible,
  onToggleRail,
}: CustomerToolbarProps) {
  return (
    <div className='flex flex-wrap items-center gap-3 font-inter'>
      <div className='relative min-w-[16rem] flex-1 sm:max-w-xs'>
        <MagnifyingGlassIcon className='absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400' />
        <input
          type='text'
          name='searchCustomers'
          aria-label='Search customers'
          value={searchQuery}
          onChange={onSearchQueryChange}
          placeholder='Search customers...'
          className='h-9 w-full rounded-lg border border-gray-300 pl-9 pr-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-200'
        />
      </div>
      <div className='w-40'>
        <FilterSelect
          placeholder='All markets'
          options={marketOptions}
          value={market === ALL_MARKETS ? null : market}
          onChange={(value) => onMarketChange(value ?? ALL_MARKETS)}
        />
      </div>
      <div className='w-40'>
        <FilterSelect
          placeholder='All segments'
          options={segmentOptions}
          value={segment}
          onChange={onSegmentChange}
        />
      </div>
      <button
        type='button'
        aria-pressed={isRailVisible}
        onClick={onToggleRail}
        className={`ml-auto inline-flex h-9 items-center gap-1.5 rounded-lg border px-3 text-sm font-medium transition-colors ${
          isRailVisible
            ? 'border-blue-200 bg-blue-50 text-primary'
            : 'border-gray-300 text-gray-700 hover:bg-gray-50'
        }`}
      >
        <FunnelIcon className='h-4 w-4' />
        Filters
      </button>
      <Checkbox
        label='Include archived'
        checked={includeArchived}
        onChange={(e) => onIncludeArchivedChange(e.target.checked)}
      />
    </div>
  );
}
